var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_11993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 19.3748V16.259L13.7558 16.399C14.1139 16.4586 14.4807 16.4396 14.8307 16.3431C15.1807 16.2467 15.5055 16.0752 15.7826 15.8405C16.0596 15.6059 16.2822 15.3137 16.4348 14.9843C16.5875 14.6549 16.6666 14.2962 16.6666 13.9331V11.8848L17.4458 11.6898C17.6401 11.6412 17.8198 11.5466 17.9699 11.414C18.12 11.2814 18.236 11.1147 18.3082 10.9279C18.3804 10.7411 18.4067 10.5397 18.3848 10.3406C18.3629 10.1415 18.2935 9.95063 18.1825 9.78398L16.6666 7.50898V6.88398C16.6666 3.19564 12.9341 0.250643 8.48496 0.66731C6.90003 0.811798 5.40224 1.45705 4.20851 2.50961C3.01477 3.56217 2.18708 4.96739 1.84529 6.52176C1.50351 8.07613 1.66538 9.69895 2.30746 11.1552C2.94954 12.6114 4.03851 13.8255 5.41663 14.6215V19.3715",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14307 6.87501C7.14315 6.4167 7.26923 5.96724 7.5075 5.57573C7.74578 5.18423 8.08709 4.86577 8.49413 4.65514C8.90118 4.44451 9.35829 4.34983 9.81551 4.38144C10.2727 4.41306 10.7125 4.56974 11.0866 4.83439C11.4608 5.09903 11.7551 5.46144 11.9372 5.882C12.1193 6.30257 12.1823 6.76511 12.1193 7.21907C12.0564 7.67303 11.8698 8.10094 11.58 8.45604C11.2903 8.81113 10.9085 9.07974 10.4764 9.23251C10.2326 9.31871 10.0215 9.47841 9.87226 9.6896C9.72301 9.90079 9.64293 10.1531 9.64307 10.4117V10.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64307 13.75C9.56019 13.75 9.4807 13.7171 9.4221 13.6585C9.36349 13.5999 9.33057 13.5204 9.33057 13.4375C9.33057 13.3546 9.36349 13.2751 9.4221 13.2165C9.4807 13.1579 9.56019 13.125 9.64307 13.125M9.64307 13.75C9.72595 13.75 9.80543 13.7171 9.86404 13.6585C9.92264 13.5999 9.95557 13.5204 9.95557 13.4375C9.95557 13.3546 9.92264 13.2751 9.86404 13.2165C9.80543 13.1579 9.72595 13.125 9.64307 13.125",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_11993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start-icon.6d99e0aa3e502096f69e953c23eac063.svg";
export { ForwardRef as ReactComponent };